import {Injectable} from '@angular/core';
import {GuidedBoxPayload} from '@ispm/shared/classes/guided-box-payload.class';
import {Message, MessageService} from '@wuitk/angular/components/notification';
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import {GuideBox} from 'diagram-js/lib/model';
import {merge} from "lodash";

@Injectable()
export class BpmnGuidedBoxService {
  public static GuidedBoxChannel = 'BPMN_GUIDED_BOX_MODAL_CHANNEL';
  private _currentElement: any;

  constructor(
    private formHandler: FormHandlerService,
    private messageService: MessageService
  ) {
  }

  public openGuideBox(htmlElement: any, guideBoxData: GuideBox, predefinedMessage: Message, isVerticalMode: boolean = false) {
    this.updateTriggeringClass(htmlElement, true);
    this.show(guideBoxData, predefinedMessage, isVerticalMode);
  }

  public showBaseGuideBox(payload: {
    automatically: boolean;
    guidingText: string;
    classNames: string;
  }): void {
    let message: Message = {
      body: payload.guidingText,
      key: BpmnGuidedBoxService.GuidedBoxChannel,
      icon: 'info',
      type: 'SINGLE_LINE',
      severity: payload.automatically ? 'warn' : 'info',
      closable: true,
      sticky: true,
    };

    if(payload.classNames && payload.classNames != "")
      message.classNames = payload.classNames;

    this.messageService.add(message);
  }

  public dismiss(): void {
    this.messageService.clearAll(BpmnGuidedBoxService.GuidedBoxChannel);
    this.updateTriggeringClass(null);
  }

  private show(guideBoxPayload: GuideBox, predefinedMessage: Message, isVerticalMode: boolean): void {
    let message: Message = {
      key: BpmnGuidedBoxService.GuidedBoxChannel,
      icon: 'info',
      type: 'SINGLE_LINE',
      severity: guideBoxPayload.automatically ? 'warn' : 'info',
      sticky: true,
      classNames: 'guide-box-preview ' + (isVerticalMode ? 'vertical-view-mode' : 'horizontal-view-mode')
    };

    if (predefinedMessage && !predefinedMessage.body) {
      predefinedMessage.body = new GuidedBoxPayload(guideBoxPayload).stripText;
    }

    message = merge(message, predefinedMessage);
    this.messageService.add(message);
  }

  public showFullNote(payload: GuideBox) {
    this.formHandler.popupDynamicFormModal(
      'Guidance Note',
      'GUIDANCE_NOTES-PROVIDER',
      {
        notes: {
          text: new GuidedBoxPayload(payload).getGuideTextWithLinks(),
          attachments: payload.attachments,
        },
        showAutomatically: payload.automatically,
      },
      'Close',
    );
  }

  private updateTriggeringClass(htmlElement: any, open?: boolean) {
    if (this._currentElement) {
      this._currentElement.classList.remove('open');
    }
    this._currentElement = htmlElement;
    if (open) {
      this._currentElement.classList.add('open');
    }
  }
}
